export default __webpack_public_path__ + "static/media/1874.1491e435.png";